export const coupaFilterPayload = {
  filters: {
    fileNames: [],
    fileCategory: [],
    createdAt: {
      date: [],
      operator: "",
    },
  },
};
